import "../scss/site.scss";

document.documentElement.classList.add("js");

const navToggle = document.querySelector(".nav-toggle");
const navMenu = document.querySelector(".nav-links");

if (navToggle && navMenu) {
  navToggle.addEventListener("click", () => {
    const isOpen = navMenu.classList.toggle("is-open");
    navToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });

  navMenu.addEventListener("click", (event) => {
    if (event.target.tagName === "A") {
      navMenu.classList.remove("is-open");
      navToggle.setAttribute("aria-expanded", "false");
    }
  });
}

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const revealItems = Array.from(document.querySelectorAll("[data-reveal]"));
const supportsObserver = "IntersectionObserver" in window;

if (revealItems.length) {
  if (!prefersReducedMotion && supportsObserver) {
    document.documentElement.classList.add("reveal-ready");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-revealed");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    revealItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const inView = rect.top < window.innerHeight * 0.9;
      if (inView) {
        item.classList.add("is-revealed");
      } else {
        observer.observe(item);
      }
    });
  } else {
    revealItems.forEach((item) => item.classList.add("is-revealed"));
  }
}

// Zoho Form Submission Handler
const zohoForm = document.getElementById("zoho-form");
if (zohoForm) {
  // Create hidden iframe for form submission
  const iframe = document.createElement('iframe');
  iframe.name = 'zoho-form-iframe';
  iframe.id = 'zoho-form-iframe';
  iframe.style.display = 'none';
  document.body.appendChild(iframe);

  // Set form target to iframe
  zohoForm.setAttribute('target', 'zoho-form-iframe');

  zohoForm.addEventListener("submit", function (event) {
    event.preventDefault();

    // Clear all error messages
    const errorMessages = document.querySelectorAll(".error-message");
    errorMessages.forEach(msg => msg.style.display = "none");

    // Validate required fields
    let isValid = true;

    // Name validation
    const nameField = document.getElementById("SingleLine");
    if (!nameField || !nameField.value.trim()) {
      const errorEl = document.getElementById("SingleLine_error");
      if (errorEl) errorEl.style.display = "block";
      isValid = false;
    }

    // Phone number validation (Strict 10-digit check)
    const phoneField = document.getElementById("PhoneNumber_countrycode");
    const phoneVal = phoneField ? phoneField.value.trim() : "";

    if (!phoneVal) {
      // Empty phone number
      const errorEl = document.getElementById("PhoneNumber_error");
      if (errorEl) {
        errorEl.textContent = "Please enter a valid phone number";
        errorEl.style.display = "block";
      }
      isValid = false;
    } else {
      // Logic for 10 digits exactly
      const cleanPhone = phoneVal.replace(/\D/g, '');
      if (cleanPhone.length !== 10) {
        const errorEl = document.getElementById("PhoneNumber_error");
        if (errorEl) {
          errorEl.textContent = "Phone number must be exactly 10 digits";
          errorEl.style.display = "block";
        }
        isValid = false;
      }
    }

    // Country Code Validation
    const codeField = document.getElementById("PhoneNumber_countrycodeval");
    if (codeField) {
      const codeVal = codeField.value.trim();
      const codeRegex = /^[+]?[0-9]{1,4}$/; // Optional + then 1-4 digits
      if (!codeVal || !codeRegex.test(codeVal)) {
        const errorEl = document.getElementById("PhoneNumber_error");
        if (errorEl) {
          errorEl.textContent = "Please check country code and phone number";
          errorEl.style.display = "block";
        }
        isValid = false;
      }
    }

    // Service dropdown validation
    const serviceField = document.getElementById("Dropdown");
    if (!serviceField || serviceField.value === "-Select-") {
      const errorEl = document.getElementById("Dropdown_error");
      if (errorEl) errorEl.style.display = "block";
      isValid = false;
    }

    // Description validation
    const descField = document.getElementById("MultiLine");
    if (!descField || !descField.value.trim()) {
      const errorEl = document.getElementById("MultiLine_error");
      if (errorEl) errorEl.style.display = "block";
      isValid = false;
    }

    // Email validation (optional but if provided should be valid)
    const emailField = document.getElementById("Email");
    if (emailField && emailField.value.trim()) {
      const emailRegex = /^[\w]([\w\-.+&'/]*)@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,22}$/;
      if (!emailRegex.test(emailField.value.trim())) {
        const errorEl = document.getElementById("Email_error");
        if (errorEl) errorEl.style.display = "block";
        isValid = false;
      }
    }

    // Company validation - only letters and numbers (Zoho requirement)
    const companyField = document.getElementById("SingleLine1");
    if (companyField && companyField.value.trim()) {
      const companyRegex = /^[a-zA-Z0-9]+$/;
      if (!companyRegex.test(companyField.value.trim())) {
        const errorEl = document.getElementById("SingleLine1_error");
        if (errorEl) {
          errorEl.textContent = "Only letters and numbers allowed (no spaces)";
          errorEl.style.display = "block";
        }
        isValid = false;
      }
    }

    if (!isValid) {
      return false;
    }

    // Submit the form to the iframe
    zohoForm.submit();

    // Show thank you message after brief delay
    setTimeout(function () {
      const formContainer = document.getElementById("form-container");
      const thankYouMsg = document.getElementById("thank-you-message");

      if (formContainer) formContainer.style.display = "none";
      if (thankYouMsg) {
        thankYouMsg.style.display = "block";
        thankYouMsg.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, 500);

    return false;
  });
}
